import { z } from 'zod';
import { CaseRoleSchema } from './access.js';
import { CaseIdSchema, EmailSchema, InvitationIdSchema } from './common.js';

export const CreateCaseInputSchema = z.object({
  navn: z.string().min(1, 'Saksnavn kan ikke være tomt'),
  saksnummer: z.string().min(1, 'Saksnummer kan ikke være tomt'),
  klient: z.string().min(1, 'Klient kan ikke være tom'),
});
export type CreateCaseInput = z.infer<typeof CreateCaseInputSchema>;

export const InviteMemberInputSchema = z.object({
  caseId: CaseIdSchema,
  email: EmailSchema,
  role: CaseRoleSchema.default('member'),
});
export type InviteMemberInput = z.infer<typeof InviteMemberInputSchema>;

export const AcceptInvitationInputSchema = z.object({
  invitationId: InvitationIdSchema,
});
export type AcceptInvitationInput = z.infer<typeof AcceptInvitationInputSchema>;

export const DeleteInvitationInputSchema = z.object({
  invitationId: InvitationIdSchema,
});
export type DeleteInvitationInput = z.infer<typeof DeleteInvitationInputSchema>;

export const ListCaseMembersInputSchema = z.object({
  caseId: CaseIdSchema,
});
export type ListCaseMembersInput = z.infer<typeof ListCaseMembersInputSchema>;
